exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swiper-pagination[data-v-1e0847ac] {\n  position: relative;\n}\n.swiper-container[data-v-1e0847ac] {\n  padding: 20px 50px;\n}\n.dark-button[data-v-1e0847ac] {\n  background: #000;\n  color: #fff;\n  height: 40px !important;\n  padding-top: 8px;\n}\n\n", ""]);

// exports
